<template>
    <button class="size-full touch-manipulation rounded-md bg-neutral-400 p-2 text-3xl font-bold text-white xl:py-4">
        <slot></slot>
    </button>
</template>
